import {useMutation} from 'react-query';
import {useDispatch} from 'react-redux';
import {updateUserLabShop} from '../../../services/shop/create';
import {useNavigate} from 'react-router-dom';
import {toggleModal} from '../../../store/redux/postSuccessModal';
import useGetProfile from '../../profile/hooks/useGetProfile';
import {useAuth} from '../../../context/authContext';
import {toast} from 'react-toastify';
import {AxiosError} from 'axios';

const UseUpdateLabShop = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {supplierProfile} = useAuth();
  const {refetch} = useGetProfile(supplierProfile?.guid || '', true);
  const {isLoading, mutate: updateLab} = useMutation({
    mutationFn: (payload: IUpdateLabShopPayload) => {
      return updateUserLabShop(payload);
    },
    onSuccess: () => {
      refetch();
      navigate('/home');
      dispatch(
        toggleModal({
          show: true,
          message: 'اطلاعات شما با موفقیت ثبت شد.',
          description: '',
        }),
      );
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, updateLab};
};

export default UseUpdateLabShop;
